import React, { useState } from 'react';
import Modal from '@components/Modal';
import { translate } from '@utils/i18n';
import TextInput from '@components/TextInput/TextInput';
import { Button } from '@components/v2/Button';
const namespace = 'features.resolution_status';
function AddStatusModal({ isOpen, onClose, onSubmit, isLoading }) {
    const [statusName, setStatusName] = useState('');
    const [nameError, setNameError] = useState('');
    const handleInputChange = (e) => {
        setStatusName(e.target.value);
        if (e.target.value.trim() !== '') {
            setNameError('');
        }
    };
    const handleSubmit = () => {
        if (statusName.trim() === '') {
            setNameError(translate('status_name_required', { namespace }));
            return;
        }
        onSubmit(statusName.trim());
        setStatusName('');
    };
    const handleCancel = () => {
        setStatusName('');
        setNameError('');
        onClose();
    };
    return (React.createElement(Modal, { isOpen: isOpen, title: translate('add_new_status', { namespace }), onClose: handleCancel, height: 200, className: "qmb-dialog" },
        React.createElement("div", { className: "form__field" },
            React.createElement(TextInput, { id: "newStatusName", name: "newStatusName", value: statusName, onChange: handleInputChange, label: translate('status_name', { namespace }), error: nameError, required: true })),
        React.createElement("div", { className: "modal__footer mt-3 pull-right", style: { justifyContent: 'space-between' } },
            React.createElement(Button, { onClick: handleCancel }, translate('cancel', { namespace: 'features.commons' })),
            React.createElement(Button, { variant: "primary", onClick: handleSubmit, disabled: isLoading }, isLoading
                ? translate('saving', { namespace: 'features.commons' })
                : translate('save', { namespace: 'features.commons' })))));
}
export default AddStatusModal;
